import { ShieldCheck, Snowflake, FileCheck, Store } from "lucide-react";
import { SHOP } from "../../storefront/StoreLayout";

const STANDARDS = [
  { icon: ShieldCheck, title: "Genuine Batch Verification", desc: "Har medicine certified distributors se — batch number aur expiry check karke hi shelf par rakhte hain." },
  { icon: Snowflake, title: "Proper Storage", desc: "Insulin aur vaccines jaise sensitive products ke liye cold-chain storage maintain hota hai." },
  { icon: FileCheck, title: "Genuine Tax Invoice", desc: "Har sale par proper bill — aapka consumer right humari zimmedari." },
  { icon: Store, title: "Real Physical Counter", desc: "Online order ke peeche ek asli dukaan hai — Laxmipur Patti, Ward 8, Kashipur." },
];

export default function StoreAbout() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-10" data-testid="store-about-page">
      <div className="grid lg:grid-cols-2 gap-10 items-center mb-14">
        <div>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-tight">
            Kashipur ka apna <span className="text-emerald-800">bharosemand</span> medical store
          </h1>
          <p className="mt-5 text-base text-slate-600 leading-relaxed">
            Trustmeds Pharma ka maqsad simple hai — Kashipur aur aas-paas ke logon tak <span className="font-semibold text-slate-800">100% asli dawaiyan, sahi ₹ daam par</span> pahunchana.
            Online duniya mein fake listings aur chhupe hue charges se pareshan customers ke liye hum ek local, licensed aur transparent option hain.
          </p>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            Har online order ke baad hamara pharmacist aapko <span className="font-semibold text-slate-800">call karke confirm</span> karta hai — kyunki dawai kisi bhi cheez ki tarah order nahi ki jaati, salaah ke saath li jaati hai.
          </p>
        </div>
        <img
          src="https://images.unsplash.com/photo-1576091358783-a212ec293ff3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
          alt="Trustmeds Pharma pharmacist consulting a customer"
          className="rounded-3xl shadow-2xl w-full object-cover aspect-[4/3]"
          data-testid="about-image"
        />
      </div>

      <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 mb-6">Hamare Quality Standards</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-14">
        {STANDARDS.map((s) => (
          <div key={s.title} className="bg-white border border-slate-200 rounded-2xl p-5">
            <s.icon className="w-7 h-7 text-emerald-700 mb-3" />
            <div className="font-semibold text-slate-900">{s.title}</div>
            <div className="text-sm text-slate-500 mt-1.5 leading-relaxed">{s.desc}</div>
          </div>
        ))}
      </div>

      <div className="bg-emerald-50 border border-emerald-200 rounded-3xl p-8 text-center">
        <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-900">Dukaan par aakar milein</h3>
        <p className="mt-2 text-sm text-slate-600 max-w-xl mx-auto">{SHOP.address}</p>
        <p className="mt-1 text-sm text-slate-600">{SHOP.hours} • {SHOP.phoneDisplay}</p>
      </div>
    </div>
  );
}
